module.exports = __webpack_public_path__ + "static/img/zhinengbaobiao.ed9204e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/zhinengbaobiao.png
// module id = bTOA
// module chunks = 1